import { render, staticRenderFns } from "./CorporateVendor.vue?vue&type=template&id=6a7cdda8"
import script from "./CorporateVendor.vue?vue&type=script&lang=js"
export * from "./CorporateVendor.vue?vue&type=script&lang=js"
import style0 from "./CorporateVendor.vue?vue&type=style&index=0&id=6a7cdda8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports